export default function getProductVariants(product, products) {
  if (product.variants === undefined) return []
  return products.filter(p => product.variants.includes(p.id))
}
